import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ILogResponse {
    itemType: string,
    response: any
}

@Injectable({
  providedIn: 'root'
})
export class ElementLogService {

  public onResponseChange: Subject<ILogResponse> = new Subject();

  constructor() { }


}

